import ClassicEditor from "ckeditor";


export class RichTextEditor
{
	/**
	 * @private
	 * @type {HTMLTextAreaElement}
	 */
	input;


	/**
	 * @param {HTMLTextAreaElement} input
	 */
	constructor (input)
	{
		this.input = input;
	}


	/**
	 *
	 */
	init ()
	{
		ClassicEditor.create(this.input, {
			removePlugins: ["EasyImage", "ImageCaption", "ImageStyle", "ImageToolbar", "ImageUpload", "Image"],
			toolbar: [
				"heading",
				"|",
				"bold",
				"italic",
				"link",
				"bulletedList",
				"numberedList",
				"blockQuote",
				"undo",
				"redo",
			],
			fillEmptyBlocks: false,
			autoParagraph: false,
			ignoreEmptyParagraph: true,
		});
	}
}
